import { read } from './http';
import { MOCK_MATCH_EVENTS } from './mock/matches.mock';
import type { MatchEvent } from '@/types';

/**
 * GET /api/v1/football/fixtures/:fixtureId/events
 *
 * The provider timeline for one match. A fixture the scoring run has not
 * reached returns `[]` — that is correct, not a failure, so the caller shows an
 * empty state rather than an error.
 */
export function getMatchEvents(
  fixtureId: number,
  signal?: AbortSignal,
): Promise<readonly MatchEvent[]> {
  return read(
    `/football/fixtures/${fixtureId}/events`,
    () => MOCK_MATCH_EVENTS[fixtureId] ?? [],
    signal,
  );
}
